package com.havn.app.core.designsystem

internal actual val havnUsesLiquidButtons: Boolean = false

actual val havnIsWebShell: Boolean = true
